module.exports = __webpack_public_path__ + "img/partner25.23f14240.jpg";